import { defineMessages } from "react-intl";

const baseId = "t.pages.UsersReferenceStepTwo.";

export default defineMessages({
  //FILTER
  allFilterLabelForm: {
    id: baseId + "filterEntitlements.allFilterLabelForm",
    defaultMessage: "Entitlements,Application",
  },
});
